import { sql } from "drizzle-orm";
import { index, jsonb, pgEnum, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core";

/** Inbound marketing prospects from the public landing page. Platform-level (NOT site-scoped). */
export const marketingLeadStatusEnum = pgEnum("marketing_lead_status", [
  "new",
  "contacted",
  "qualified",
  "won",
  "lost",
  "archived",
]);

export const marketingLeads = pgTable(
  "marketing_leads",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    /** The dealer's existing website domain (Step 1 of the form). */
    domain: text("domain").notNull(),
    name: text("name"),
    email: text("email"),
    phone: text("phone"),
    /** Attribution captured on submit. */
    utm: jsonb("utm")
      .$type<Record<string, string>>()
      .notNull()
      .default(sql`'{}'::jsonb`),
    referrer: text("referrer"),
    userAgent: text("user_agent"),
    landingPath: text("landing_path"),
    status: marketingLeadStatusEnum("status").notNull().default("new"),
    createdAt: timestamp("created_at", { withTimezone: true })
      .notNull()
      .default(sql`now()`),
  },
  (t) => ({
    createdIdx: index("marketing_leads_created_idx").on(t.createdAt.desc()),
    emailIdx: index("marketing_leads_email_idx").on(t.email),
  }),
);

export type MarketingLead = typeof marketingLeads.$inferSelect;
export type NewMarketingLead = typeof marketingLeads.$inferInsert;
